<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>学习计划</span><span>/</span><span>
        <router-link to="/Company/Plan">计划管理</router-link>
      </span><span>/</span><span>{{ruleForm.id?'编辑':'新建'}}计划</span>
    </div>
    <div class="comUserInfo" v-loading="loading">
      <div class="comUserInfo-header">
        <el-button type="success" @click="onSave(1)">提交</el-button>
        <el-button type="primary" @click="onSave(0)" style="margin-right: 10px;">保存</el-button>
      </div>
      <div class="comUserInfo-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          style="width: 770px;margin: 20px 0px 20px 20px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="标题：" prop="planname">
            <el-input v-model="ruleForm.planname" placeholder="请输入计划标题"></el-input>
          </el-form-item>
          <el-form-item label="培训部门：" prop="orgId">
            <el-cascader ref="orgCascader" @change="showText=false" :props="props" :visible-change="orgVisible"
              :show-all-levels="false" v-model="orgId" :placeholder="showText?ruleForm.orgName:'选择培训部门'"
              style="width: 100%;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="课时：" prop="littletime">
            <el-input-number v-model="ruleForm.littletime" placeholder="请选择课时" style="width: 100%;"
              controls-position="right" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="培训方式：" prop="itype">
            <el-select v-model="ruleForm.itype" placeholder="请选择培训方式" style="width: 100%;">
              <el-option v-for="item in optionsType" :key="item.val" :label="item.text" :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训类别：" prop="ontype">
            <el-select @change="getParName" v-model="ruleForm.ontype" placeholder="请选择培训类别" style="width: 100%;">
              <el-option v-for="item in pxoptions" :key="item.uniqueCode" :label="item.text" :value="item.uniqueCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有效期：">
            <el-date-picker style="width: 100%;" v-model="rangTime" value-format="yyyy-MM-dd" type="daterange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="课程来源：" prop="flag" v-if="ruleForm.itype=='1'">
            <el-select style="width: 100%;" @change="changeFlag" v-model="ruleForm.flag" placeholder="请选择来源" clearable>
              <el-option v-for="item in itypes" :key="item.val" :label="item.text" :value="item.val">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="关联课程：" prop="productPlan" v-if="ruleForm.itype=='1'">
            <div>
              <curse-btn flag="3" :currentUser="currentUser" :selectCurseIds="selectCurseIds" :options="options"
                :wjSrc="wjSrc" @changeCurse="changeCurse" />
            </div>
          </el-form-item>
          <el-form-item label="参与学员：" prop="userPlan" v-if="ruleForm.itype=='1'">
            <div>
              <user-btn :tableUserList="tableUserList" :itype="3" :selectCurseList="selectCurseList"
                :selectUserIds="selectUserIds" :orgId="orgId" :selectUserList="selectUserList"
                @changeUser="changeUser" />
            </div>
            <div style="margin-top: 10px;">
              <span class="userSpan" v-for="item in selectUserList">{{item.realName}}<i class="el-icon-close"
                  @click="delUser(item.id)"></i></span>
            </div>
          </el-form-item>
          <el-form-item label="" v-if="ruleForm.itype=='1'">
            <el-table :data="selectCurseList" style="width: 100%">
              <el-table-column prop="img" label="封面" width="70">
                <template slot-scope="scope">
                  <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
                </template>
              </el-table-column>
              <el-table-column prop="cname" label="名称" width="180">
              </el-table-column>
              <el-table-column prop="itypeName" label="课程类别" width="180">
              </el-table-column>
              <el-table-column prop="allxstime" label="总课时">
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <span style="color:#0071BA;cursor: pointer;font-size: 14px;" @click="delCurse(scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="培训人数：" prop="pnum" v-if="ruleForm.itype=='2'">
            <el-input v-model="ruleForm.pnum" placeholder="请输入培训人数"></el-input>
          </el-form-item>
          <el-form-item label="培训文件：" prop="flag" v-if="ruleForm.itype=='2'">
            <el-upload class="upload-demo" :data="wjparams" action="/safety/file/attachment/upload_new.htm"
              :on-remove="handleRemove" multiple :on-success="onSuccess" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">可上传图片、文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import UserBtn from '../common/UserBtn';
  import CurseBtn from '../common/CurseBtn';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      var $this = this;
      return {
        loading: false,
        itypes: [{
          text: '购买',
          val: 2
        }, {
          text: '自研',
          val: 3
        }],
        selectUserList: [],
        selectUserIds: [],
        itype: '',
        rules: {
          orgId: [{
            required: true,
            message: '所属组织不能为空',
            trigger: 'blur'
          }],
          planname: [{
            required: true,
            message: '计划标题不能为空',
            trigger: 'blur'
          }],
          littletime: [{
            required: true,
            message: '课时不能为空',
            trigger: 'blur'
          }],
          itype: [{
            required: true,
            message: '培训方式不能为空',
            trigger: 'blur'
          }],
          ontype: [{
            required: true,
            message: '培训类别不能为空',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          planname: '',
          littletime: '',
          endtime: '',
          startime: '',
          productPlan: [],
          userPlan: [],
          itype: '',
          fileid: '',
          filepath: '',
          flag: 1
        },
        fileList: [],
        tableData: [],
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        userTable: {
          rows: [],
          total: 0
        },
        options: [],
        optionsType: [{
            text: '线上培训',
            val: '1'
          },
          {
            text: '线下培训',
            val: '2'
          }
        ],
        selectCurseIds: [],
        selectCurseList: [],
        rangTime: [],
        tableUserList: [],
        isgetDetail: false,
        wjparams: {
          "dir": "zxkt",
          "businessClass": "pxwjk",
          "businessId": "pxsrc",
          "ispdf": "1"
        },
        orgVisible: false,
        orgId: [],
        showText: false,
        pxoptions: [], //培训类别
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value,
              children
            } = node;
            var loadUrl = '/system/organization/myTree.htm?type=SYS_ORGTYPE_02'
            if (value && children.length == 0) {
              loadUrl += '&id=' + value;
            }
            if (children && children.length > 0) {
              resolve(children);
            } else {
              $this.$axios.get(loadUrl).then(res => {
                var data = res.data;
                if (data.length > 0) {
                  resolve($this.getNodes(data));
                } else {
                  resolve([]);
                }
              })
            };
          },
        },
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        if (this.ruleForm.avatarurl) {
          this.delFile(this.ruleForm.avatarurl);
        }
        this.$set(this.ruleForm, 'avatarurl', res.data.filePath);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      getNodes: function(arr) {
        const nodes = arr.map(item => ({
          value: item.id,
          label: item.text,
          leaf: !item.isParent,
          children: item.children.length > 0 ? this.getNodes(item.children) : []
        }));
        return nodes;
      },
      // 培训文件
      onSuccess(res, file) {
        res.data.name = res.data.fileName;
        this.fileList.push(res.data);
      },
      handleRemove(file, filelist) {
        this.fileList = filelist;
        this.delFile(file.id, 'id');
      },
      delFile: function(filePath, flag) {
        var fileId = ''
        if (flag == 'id') {
          fileId = filePath;
        } else {
          var arr = filePath.split('/');
          var arr0 = arr[arr.length - 1].split('.');
          fileId = arr0[0];
        };
        this.$axios.post('/file/attachment/del.htm', this.$qs.stringify({
          id: fileId
        })).then(
          res => {
            var data = res.data;
            if (data.stat == '1') {} else {
              // this.$message.error(data.message);
            }
          })
      },
      // 获取培训类别名称
      getParName: function(val) {
        var list = [];
        if (val.indexOf('ZXKT_producttype_2') >= 0) {
          list = this.options[0].children
        } else {
          list = this.options[1].children
        };
        // list.map((item) => {
        //   if (item.uniqueCode == val) {
        //     this.$set(this.ruleForm, 'parentname', item.text);
        //   }
        // });
      },
      onSave: function(state) {
        var $this = this;
        var nodes = this.$refs.orgCascader.getCheckedNodes(1)[0]; //培训部门
        if (nodes) {
          this.$set(this.ruleForm, 'orgId', this.orgId[this.orgId.length - 1]);
        };
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$set(this.ruleForm, 'endtime', this.rangTime[1]);
            var endtime = new Date(this.rangTime[1]);
            var productPlan = [];
            var iscq = false;
            this.selectCurseList.map((item) => {
              var yxq = new Date(item.endtime)
              if (endtime.getTime() > yxq.getTime()) {
                this.$message.warning("课程：" + item.cname + "的有效期为" + item.endtime + "，则该计划的结束时间需为" + item
                  .endtime + "或在此之前！")
                iscq = true;
                return;
              }
              productPlan.push({
                productname: item.cname,
                productid: item.id,
                itype: item.itype,
                allxstime: item.allxstime,
                img: item.img,
                itypeName: item.itypeName
              });
            });
            if (iscq) {
              return;
            }
            var userPlan = [];
            this.selectUserList.map((item) => {
              userPlan.push({
                username: item.realName,
                userid: item.id,
                avatarurl: item.avatarurl
              });
            });
            this.$set(this.ruleForm, 'productPlan', JSON.stringify(productPlan));
            this.$set(this.ruleForm, 'userPlan', JSON.stringify(userPlan));

            this.$set(this.ruleForm, 'endtime', this.rangTime[1]);
            this.$set(this.ruleForm, 'startime', this.rangTime[0]);

            this.$set(this.ruleForm, 'state', state);
            if (this.ruleForm.itype == 1) {
              this.$set(this.ruleForm, 'pnum', userPlan.length);
            }
            var filestr = this.fileList.map((item) => {
              return {
                fileid: item.id,
                filepath: item.filePath,
                name: item.fileName,
              }
            });
            this.$set(this.ruleForm, 'filestr', JSON.stringify(filestr));

            var url = '/kt/ktProductLeanplan/add.htm'
            if (this.ruleForm.id) {
              url = '/kt/ktProductLeanplan/update.htm'
            };
            this.loading = true;
            this.$axios.post(url, this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                this.loading = false;
                if (data.stat == '1') {
                  this.$message({
                    message: data.message,
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.push('/Company/Plan');
                    }
                  });
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getData: function(id) {
        this.$axios.get('/kt/ktProductLeanplan/detail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.loading = false;
            this.ruleForm = {
              planname: data.data.planname,
              littletime: data.data.littletime,
              endtime: data.data.endtime,
              startime: data.data.startime,
              productPlan: [],
              userPlan: [],
              itype: data.data.itype,
              id: data.data.id,
              flag: data.data.flag,
              pnum: data.data.pnum,
              orgId: data.data.orgId,
              ontype: data.data.ontype,
              orgName: data.data.orgName
            };
            this.showText = true;
            this.orgId = [data.data.orgId];

            var selectCurseList = [];
            var selectCurseIds = [];

            data.data.ktProductPlanList.map((item) => {
              selectCurseIds.push(item.productid);
              selectCurseList.push({
                cname: item.productname,
                id: item.productid,
                itype: item.itype,
                allxstime: item.allxstime,
                img: item.img,
                itypeName: item.itypeName
              })
            });

            var selectUserList = [];
            var selectUserIds = [];
            data.data.ktUserPlanlist.map((item) => {
              selectUserIds.push(item.userid);
              selectUserList.push({
                realName: item.username,
                id: item.userid,
                avatarurl: item.avatarurl
              });
            })
            this.isgetDetail = true;
            this.selectCurseList = selectCurseList;
            this.selectCurseIds = selectCurseIds;
            this.isgetDetail = true;
            this.selectUserIds = selectUserIds;
            this.selectUserList = selectUserList;
            var fileList = data.data.filestr ? JSON.parse(data.data.filestr) : [];
            this.fileList = fileList.map((item) => {
              return {
                ...item,
                id: item.fileid,
                filePath: item.filepath,
                fileName: item.name
              }
            });
            console.log(this.fileList)

            this.rangTime = [data.data.startime, data.data.endtime]
          } else {
            this.$message.error(data.message);
          }
        })
      },
      changeUser: function(selectUserIds, selectUserList) {
        this.selectUserList = selectUserList;
        this.selectUserIds = selectUserIds;
      },
      changeCurse: function(ids, list) {
        this.selectCurseIds = ids;
        this.selectCurseList = list;
        var bmshowparam = {
          productid: list[0].id,
          cid: this.currentUser.cid
        }
        // 购买课程   只能选择已报名的人员
        if (this.ruleForm.flag == '2') {
          this.$axios.get('/kt/ktProductAppy/getlist.htm?' + this.$qs.stringify(bmshowparam)).then(res => {
            var data = res.data;
            if (data) {
              this.tableUserList = data;
            } else {
              this.$message.error(data.message);
            }
          });
        }
      },
      delUser: function(id) {
        var arr = [];
        var narr = []
        this.selectUserList.map((item) => {
          if (item.id != id) {
            arr.push(item);
            narr.push(item.id);
          }
        })
        this.selectUserIds = narr;
        this.selectUserList = arr;
      },
      delCurse: function(row) {
        var id = row.id;
        var arr = [];
        var narr = []
        this.selectCurseList.map((item) => {
          if (item.id != id) {
            arr.push(item);
            narr.push(item.id);
          }
        })
        this.selectCurseIds = narr;
        this.selectCurseList = arr;
      },
      // 切换课程来源   已选择的课程全部删除
      changeFlag: function(flag) {
        this.selectCurseIds = [];
        this.selectCurseList = [];
      },
      getItype: function() {
        if (localStorage.getItem('zywsItypeList')) {
          this.options = JSON.parse(localStorage.getItem('zywsItypeList'));
        } else {
          var $this = this;
          this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_producttype', {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            this.options = data;
            data.map((item, i) => {
              $this.getNextItype(item.uniqueCode, i);
              if (i == data.length - 1) {
                setTimeout(() => {
                  localStorage.setItem('zywsItypeList', JSON.stringify(this.options))
                }, 1000)
              }
            })
          });
        }
      },
      getNextItype: function(supCode, i) {
        this.$axios.get('/system/datadict/tree.htm?supCode=' + supCode, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.options[i].children = data;
        })
      },
      getPxitype: function() {
        this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_pxitype', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.pxoptions = data;
        })
      }
    },
    watch: {
      selectCurseIds: {
        handler(val, oldVal) {
          if (this.isgetDetail) {
            this.isgetDetail = false;
          } else {
            this.selectUserList = [];
            this.selectUserIds = [];
          }
        },
        deep: true //true 深度监听
      },

    },
    components: {
      UserBtn,
      CurseBtn
    },
    created: function() {
      // 人员详情
      if (this.$route.query.id) {
        this.loading = true;
        this.getData(this.$route.query.id)
      } else {
        this.orgId = [this.currentUser.orgId];

        this.$set(this.ruleForm, 'orgId', this.currentUser.orgId);
        this.$set(this.ruleForm, 'orgName', this.currentUser.orgName);
        this.showText = true;
      }

      // 获取类别字典
      this.getItype();
      // 培训类别
      this.getPxitype();
    },

  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .userSpan {
    padding: 8px 10px;
    background-color: #f2f2f2;
    font-size: 14px;
    border-radius: 4px;
    margin-right: 10px;
  }

  .userSpan i {
    padding-left: 8px;
    cursor: pointer;
  }

  .addKcBtn {
    width: 139px;
    height: 32px;
    border: 1px dashed #0071ba;
    border-radius: 4px;
    text-align: center;
    color: #0071BA;
    line-height: 32px;
    cursor: pointer;
  }

  .addKcBtn i {
    padding-right: 3px;
  }

  .el-dialog__body {
    padding: 10px 20px;
  }

  .comUserInfo-content .el-input-number .el-input__inner {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/company/PlanInfo.vue